// token key
export const TOKEN_KEY = 'COPY_MACHINE_TOKEN__'
export const USER_INFO_KEY = 'COPY_MACHINE_USER_INFO__'
export const TENANT_ID_KEY = 'COPY_MACHINE_TENANT_ID__'

// 全局静音管理
export const GLOBAL_MUTE_KEY = 'COPY_MACHINE_GLOBAL_MUTE__'
